//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'IronDeficiency',
  data() {
    return {
      defaultJson:{
        "Weight": "体重",
        "Hemoglobin": "血红蛋白",
      },
      form:{
        weight:'',
        hb:''
      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = form.weight >= 35 ? form.weight * [15 - form.hb] * 2.4 + 500 : form.weight * [15 - form.hb] * 2.4 + 15 * form.weight
        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/IronDeficiency.vue